"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RemoveButton = exports.Options = exports.Option = exports.MenuList = exports.Indicator = exports.Container = exports.Button = exports.ArrowDown = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Container = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  display: inline-flex;\n  z-index: 999999999999999999999999999999;\n  max-width: 375px;\n  width: 100%;\n  margin: 10px;\n  height: 45px;\n  ", "\n"])), function (_ref) {
  var $bsStyle = _ref.$bsStyle;
  return $bsStyle || '';
});
exports.Container = Container;
var MenuList = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  color: white;\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  width: 100%;\n  z-index: 2;\n  ", "\n"])), function (_ref2) {
  var $bsStyle = _ref2.$bsStyle;
  return $bsStyle || '';
});
exports.MenuList = MenuList;
var Options = _styledComponents.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  list-style: none;\n  padding: 0;\n  margin: 0 5px;\n  height: 100%;\n  ", ";\n  transition: transform 100ms ease-in-out;\n  transform-origin: top;\n  transform: ", ";\n  ", "\n"])), function (_ref3) {
  var visibility = _ref3.visibility;
  return visibility ? 'max-height: 100%;' : 'max-height: 0;';
}, function (_ref4) {
  var visibility = _ref4.visibility;
  return visibility ? 'scaleY(1)' : 'scaleY(0)';
}, function (_ref5) {
  var $bsStyle = _ref5.$bsStyle;
  return $bsStyle || '';
});
exports.Options = Options;
var Option = _styledComponents.default.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  padding: 8px 12px;\n  background: black;\n  margin-top: 10px;\n  border-radius: 20px;\n  height: 100%;\n  max-height: 45px;\n  text-transform: uppercase;\n  &:hover {\n    background-color: rgba(0, 0, 0, 0.8);\n    filter: brightness(0.9);\n    cursor: pointer;\n  }\n  ", "\n"])), function (_ref6) {
  var $bsStyle = _ref6.$bsStyle;
  return $bsStyle || '';
});
exports.Option = Option;
var Button = _styledComponents.default.button.attrs({
  type: 'button'
})(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  height: 100%;\n  align-items: center;\n  padding: 8px 12px;\n  background: black;\n  cursor: pointer;\n  border: none;\n  font-family: 'Gentleman', Arial, sans-serif;\n  color: #fff;\n  text-transform: uppercase;\n  width: 100%;\n  border-radius: 33px;\n  max-height: 50px;\n  font-weight: bold;\n  &:disabled {\n    cursor: default;\n  }\n  &:active,\n  :focus {\n    outline: 0;\n    -webkit-box-shadow: none;\n    box-shadow: none;\n  }\n  ", "\n"])), function (_ref7) {
  var $bsStyle = _ref7.$bsStyle;
  return $bsStyle || '';
});
exports.Button = Button;
var ArrowDown = _styledComponents.default.img.attrs({
  alt: 'arrow-down'
})(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  max-height: 10px;\n  width: 100%;\n  transform: ", ";\n"])), function (_ref8) {
  var menuOpen = _ref8.menuOpen;
  return !menuOpen ? 'translateY(0)' : 'rotate(0.5turn)';
});
exports.ArrowDown = ArrowDown;
var Indicator = _styledComponents.default.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  margin: auto 10px auto auto;\n"])));
exports.Indicator = Indicator;
var RemoveButton = _styledComponents.default.button.attrs({
  type: 'button'
})(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  padding-right: 5px;\n  border: none;\n  background: transparent;\n  color: white;\n  cursor: pointer;\n  font-size: 16px;\n  &:after {\n    content: 'x';\n  }\n  &:active,\n  :focus {\n    outline: 0;\n    -webkit-box-shadow: none;\n    box-shadow: none;\n  }\n"])));
exports.RemoveButton = RemoveButton;